<ng-container *transloco="let t">
  <div *ngIf="showBanner" class="cookie-banner">
    <div class="d-flex justify-content-center align-items-center">
      <p class="text-center">
        {{ t('app.cookie.banner.text') }}
        <a [routerLink]="[COOKIE_POLICY_ROUTE]">{{ t('app.cookie.banner.learn.more') }}</a>
      </p>
    </div>
    <div class="d-flex flex-row align-items-center pt-4 px-1 pb-1">
      <div class="me-2 flex-grow-1">
        <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--grey-neutral-800)'"
                        [text]="t('request.action.accept')|uppercase" [borderColor]="'var(--teal-500)'"
                        (click)="acceptCookies()" [isFullWidth]="true"></app-button-alt>
      </div>
      <div class="flex-grow-1">
        <app-button-alt [text]="t('request.action.decline')|uppercase"
                        (onClickCallback)="declineCookies()" [isFullWidth]="true"></app-button-alt>
      </div>
    </div>
  </div>
</ng-container>

